import { DepartmentCategoryModel } from '@/models/diagnosis/category';
import { ROUTES } from '@/types/common';
import { addQueryString } from '@/utils/url';
import Link from 'next/link';

interface Props {
  departmentCategory: DepartmentCategoryModel;
}
const Department = (props: Props) => {
  return (
    <li className={'border-gray-50 border-b-[1px] border-solid'}>
      <Link
        href={
          ROUTES.DISEASE_ENCYCLOPEDIA.SEARCH.path +
          addQueryString({
            keyword: props.departmentCategory.name,
          })
        }
      >
        <a className={'flex items-center justify-between p-[24px]'}>
          <div>
            <h3 className={'typography-ui-17sb mb-[4px] text-gray-700'}>{props.departmentCategory.name}</h3>
            <p className={'typography-ui-15r text-gray-400'}>{props.departmentCategory.description}</p>
          </div>
          <img
            src={props.departmentCategory.icon}
            alt={props.departmentCategory.name}
            className={'aspect-square w-[40px]'}
          />
        </a>
      </Link>
    </li>
  );
};

export default Department;
